<template>
    <div class="collage">
      <div class="collage__top">
          <img class="collage__image" :src="imageOneFull" />
      </div>
        <div class="collage__bottom">
          <div class="collage__left">
            <img :src="imageTwoFull" />
          </div>
          <div class="collage__right">
            <img :src="imageThreeFull" />
          </div>
        </div>
    </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue
} from 'vue-property-decorator';

@Component
export default class CollageComponent extends Vue {
  @Prop({ default: 'bmw-2-series-collage-main.png' })
  public imageOne!: string;

  @Prop({ default: 'bmw-2-series-collage-rear.png' })
  public imageTwo!: string;

  @Prop({ default: 'bmw-2-series-collage-interior.png' })
  public imageThree!: string;

  public get baseUrl() {
    return process.env.BASE_URL;
  }

  public isFullPath(image: string): boolean {
    return image !== null && image.toLowerCase().startsWith('http');
  }

  public buildFullPath(image: string): string {
    return `${this.baseUrl}images/kmi/${image}`;
  }

  public get imageOneFull(): string {
    return this.isFullPath(this.imageOne) ? this.imageOne : this.buildFullPath(this.imageOne);
  }

  public get imageTwoFull(): string {
    return this.isFullPath(this.imageTwo) ? this.imageTwo : this.buildFullPath(this.imageTwo);
  }

  public get imageThreeFull(): string {
    return this.isFullPath(this.imageThree) ? this.imageThree : this.buildFullPath(this.imageThree);
  }
}
</script>
